














import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { Asset } from '@/js/Asset'

@Component({})
export default class AssetRow extends Vue {
    @Prop() asset!: Asset

    get avgTxValue(): string {
        return this.asset.txCount_day > 0
            ? this.asset.volume_day
                  .div(this.asset.txCount_day)
                  .toLocaleString(0)
            : ''
    }
}
